import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { TooltipWrapper } from './StyleTooltip';

const propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

const Tooltip = ({ id, children }) => {
    const node = useRef();
    const [isHovered, setState] = useState(false);

    let trigger = null;
    let content = null;

    React.Children.forEach(children, child => {
        if (!child.type) {
            return;
        }

        if (child.type.displayName === 'Trigger') {
            trigger = React.cloneElement(
                child,
                {
                    'aria-describedby': id,
                }
            );
        }

        if (child.type.displayName === 'Content') {
            content = React.cloneElement(
                child, { id }
            );
        }
    });

    return (
        <TooltipWrapper
            ref={node}
            onMouseEnter={() => setState(true)}
            onMouseLeave={() => setState(false)}
        >
            {trigger}
            {isHovered && content}
        </TooltipWrapper>
    );
};

Tooltip.propTypes = propTypes;

export default Tooltip;
